import {Directive, effect, ElementRef, inject, input} from '@angular/core';
import {Utilities} from '@xmedical/core';

@Directive({
    selector: '[xuiBackgroundColourOpacity]',
})
export class BackgroundColourOpacityDirective {
  backgroundColor = input<string>('');
  opacity = input<number>(0.5);

  private readonly element: HTMLElement = inject(ElementRef).nativeElement;

  constructor() {
    effect(() => {
      const color = this.backgroundColor();
      const opacityValue = this.opacity();
      if (!color) {
        return;
      }
      const colorComponents = Utilities.hexToRgb(color);
      this.element.style.backgroundColor = `rgba(${colorComponents.r},${colorComponents.g},${colorComponents.b},${opacityValue})`;
    });
  }
}
